import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PackVerification_ds_get_failed_verification_reasoncodes_by_shippingContainerIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shippingContainerIds: number[] }): 
  Promise<{ result: { Id?: number, TasksForActualSourceShippingContainer?: { StatusId?: number, ReasonCode?: { Name?: string } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerIds)) {
      missingRequiredInParams.push('\'shippingContainerIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_failed_verification_reasoncodes_by_shippingContainerIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shippingContainerIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, TasksForActualSourceShippingContainer?: { StatusId?: number, ReasonCode?: { Name?: string } }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerIds)) {
      missingRequiredInParams.push('\'shippingContainerIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_failed_verification_reasoncodes_by_shippingContainerIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shippingContainerIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, TasksForActualSourceShippingContainer?: { StatusId?: number, ReasonCode?: { Name?: string } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerIds)) {
      missingRequiredInParams.push('\'shippingContainerIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_failed_verification_reasoncodes_by_shippingContainerIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shippingContainerIds: number[]    }) {
        if(isNil(inParams.shippingContainerIds)) {
          return true; 
        }
      return false;
    }
}
